import SectionSummary from '@components/molecules/cpdEnrollment/confirmAllInformation/sectionSummary';
import { PersonSummaryInformation } from 'src/helpers/constants';
import { formatCitizenId } from 'src/helpers/utils';

type PersonalInformationProps = {
  person: PersonSummaryInformation;
};
const PersonSummary = ({ person }: PersonalInformationProps) => {
  const buildFullName = (prefix: string, firstName: string, lastName: string) => `${prefix}${firstName} ${lastName}`;
  return (
    <SectionSummary
      title="ข้อมูลส่วนตัว"
      items={{
        'คำนำหน้า/ชื่อจริง/นามสกุล (ภาษาไทย)': buildFullName(
          (person.prefix === 'other' ? person.inputPrefix : person.prefix) as string,
          person.firstName,
          person.lastName,
        ),
        'เลขประจำตัวประชาชน 13 หลัก': formatCitizenId(person.citizenId),
        อีเมล: person.email,
        หมายเลขโทรศัพท์: person.mobile,
      }}
    />
  );
};

export default PersonSummary;
